import { IProps } from '@/Interfaces/Icons/Props.interface';
import classNames from 'classnames';

const TvFilledIcon = ({ className }: IProps) => {
  const iconClassName = classNames('tv-filled-icon', className);

  return (
    <svg className={iconClassName} width='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M8.78526 3.35413C9.93386 3.35412 10.8436 3.35411 11.5556 3.4409C12.2884 3.53023 12.8815 3.71842 13.3492 4.1425C13.817 4.56657 14.0245 5.10431 14.123 5.76868C14.2188 6.41424 14.2188 7.2391 14.2188 8.28049V8.34443C14.2188 9.38582 14.2188 10.2107 14.123 10.8562C14.0245 11.5206 13.817 12.0583 13.3492 12.4824C12.8815 12.9065 12.2884 13.0947 11.5556 13.184C10.8436 13.2708 9.93388 13.2708 8.78529 13.2708H8.78526H6.21474H6.21471C5.06613 13.2708 4.15636 13.2708 3.44436 13.184C2.7116 13.0947 2.1185 12.9065 1.65078 12.4824C1.18305 12.0583 0.975476 11.5206 0.876959 10.8562C0.781231 10.2107 0.781239 9.38583 0.78125 8.34443V8.28049C0.781239 7.23909 0.781231 6.41423 0.876959 5.76868C0.975476 5.10431 1.18305 4.56657 1.65078 4.1425C2.1185 3.71842 2.7116 3.53023 3.44436 3.4409C4.15637 3.35411 5.06614 3.35412 6.21473 3.35413H6.21474H8.78526Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.55806 0.89998C9.80214 0.672175 10.1979 0.672175 10.4419 0.89998C10.686 1.12779 10.686 1.49713 10.4419 1.72494L7.94194 4.05827C7.69786 4.28608 7.30214 4.28608 7.05806 4.05827L5.18306 2.30827C4.93898 2.08047 4.93898 1.71112 5.18306 1.48331C5.42714 1.25551 5.82286 1.25551 6.06694 1.48331L7.5 2.82083L9.55806 0.89998Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default TvFilledIcon;
